export const gettersAlert = {
    getAlertState(state) {
        return state
    },
    hasAlert(state) {
        return state.isActive
    },
}
